import React from 'react';

export interface DataItem {
  label: string;
  value: string;
  highlight?: boolean;
}

interface DataGridProps {
  items: DataItem[];
}

export const DataGrid: React.FC<DataGridProps> = ({ items }) => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
      margin: '8px 0'
    }}>
      {items.map((item, index) => (
        <div key={index} style={{
          background: item.highlight ? '#22c55e0a' : 'var(--bg-box, white)',
          border: `0.5px solid ${item.highlight ? '#22c55e33' : 'var(--border-color, #e8e8e8)'}`,
          borderRadius: '8px',
          padding: '8px 12px'
        }}>
          <div style={{ 
            fontSize: '10px', 
            color: item.highlight ? '#22c55e' : 'var(--text-muted, #888)',
            textTransform: 'uppercase', 
            letterSpacing: '0.5px' 
          }}>
            {item.label}
          </div>
          <div style={{ 
            fontSize: '15px', 
            fontWeight: 600,
            color: 'var(--text-main, #111)', 
            marginTop: '2px' 
          }}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};
